<template>
  <td class="text-gray-80 border-gray-30 border px-3 py-2 font-normal"><slot /></td>
</template>
